import * as React from "react";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { Experiment, isVariantEnabled } from "components/utility/experiment";

export const HotelAllInclusiveMessage = (props: { seeMoreMessage?: string; context: ExtendedContextStore }) => {
  const { seeMoreMessage, context } = props;

  if (!isVariantEnabled(context, Experiment.Destination_Orientation_we_dont_have_all_inclusive) || !seeMoreMessage) {
    return null;
  }

  const createMarkup = (text: string) => {
    const htmlWithStyle = text.replace(/<a/gi, '$& class="uitk-link"');

    return { __html: htmlWithStyle };
  };

  return (
    <div className="all-t-padding-one all-b-padding-four">
      <TrackedLink moduleName="Hotel.AllInclusive.Message.SeeAll.Link" rffr="Hotel.AllInclusive.Message.SeeAll.Link">
        <div className="uitk-type-300" dangerouslySetInnerHTML={createMarkup(seeMoreMessage)} />
      </TrackedLink>
    </div>
  );
};
